import IntervalRecurrencePatternBaseType from 'owa-service/lib/contract/IntervalRecurrencePatternBaseType';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import {
    isRelativeMonthlyRecurrence,
    isYearlyRecurrence,
    isRelativeYearlyRecurrence,
} from './checkRecurrenceTypes';

/**
 * Utility to check whether the recurrence is custom type or not.
 * @param recurrence: RecurrenceType, recurrence to check cutom type.
 */
export default function isCustomRecurrence(recurrence: RecurrenceType): boolean {
    if (!recurrence) {
        return false;
    }

    // As YearlyRecurrence doesnt support interval, check if it is relative recurrence or else return false.
    if (isYearlyRecurrence(recurrence)) {
        return isRelativeYearlyRecurrence(recurrence);
    }

    let recurrencePattern = recurrence.RecurrencePattern as IntervalRecurrencePatternBaseType;

    // It is a custom recurrence if the interval more than one or if it is a relative recurrence
    return recurrencePattern.Interval > 1 || isRelativeMonthlyRecurrence(recurrence);
}
